<template>
    <!-- 条件查询，多用于分页列表，目前是疵点和落布标签 -->
	<el-input placeholder="请输入内容" v-model="queryInfo" clearable
        @clear="clickClear" :style="`width:${width}`">
      <el-select v-model="selectOption" slot="prepend" placeholder="请选择" :class="selectClass">
        <el-option v-for="(obj,index) in options" :key="index"
            :label="obj.label" :value="obj.value"/>
      </el-select>
      <el-button slot="append" icon="el-icon-search" @click="clickQuery"/>
    </el-input>
</template>

<script>
	export default {
        props: {
            // {label:'',value:''}
            options:{
                type: Array,
                default: []
            },
            width: '100%',
            selectClass:{
                type: Object,
                default: {
                    width: '120px'
                }
            },
            pageInfo: {}
        },
		data() {
			return {
                queryInfo:'',
                selectOption:'',
                firstPageInfo:''
			}
		},
		methods: {
            // 点击查询按钮
            clickQuery() {
                if(!this.utils.isEmpty(this.selectOption)) {
                    const formatPageInfo = this._.cloneDeep(this.firstPageInfo)
                    formatPageInfo[this.selectOption] = this.queryInfo
                    this.$emit('query',formatPageInfo)
                } else {
                    this.$Message.error('未选择查询条件')
                }   
            },
            // 清空
            clickClear() {
                this.$emit('clear',this.firstPageInfo)
            }
		},
		created() {
            this.firstPageInfo = this.pageInfo
        }
	}
</script>

<style scoped lang="scss">
.el-select{
    width:130px
}
</style>
